import useHook from './hooks'
import styles from './style.module.scss'
import TableAntd from '../../components/TableAntd'
import { Button, Col, Form, Input, Row, Space, Typography } from 'antd'
import { orderDetailLinkRender } from '../orderassurance/Lander'
import AddOrderModal from './components/AddOrderModal'
import moment from 'moment'
import {
  SignVoucherState,
  returnMoneyStatedictInvert,
  signVoucherStateDict,
} from '../../tools/state'
import { customInvoiceEnum } from '../../global/enums'

export default function FinancialReconciliationEdit() {
  const {
    form,
    hooksState,
    totalPrice,
    enterpriseInfo,
    onChangeCheck,
    handleClosePage,
    handleSubmit,
    handleFormDataChange,
    handleAddClick,
    handleAddOrderModalCancel,
    onDelete,
    handleAddFinished,
  } = useHook()

  const {
    dataSource,
    isSubmitButtonLoading,
    isAddModalVisivle,
    routeParams,
    originRemovedList,
  } = hooksState

  const formConfig = {
    订单明细: {
      columns: [
        {
          key: 'orderNo',
          dataIndex: 'orderNo',
          title: '客户订单号',
          render: orderDetailLinkRender,
        },
        {
          key: 'customer',
          dataIndex: 'customer',
          title: '客户名称',
        },
        {
          key: 'platform',
          dataIndex: 'platform',
          title: '下单平台',
        },

        {
          key: 'orderTime',
          dataIndex: 'orderTime',
          title: '下单时间',
          render: (text: any) => moment(text).format('YYYY-MM-DD HH:mm:ss'),
        },
        {
          key: 'orderPrice',
          dataIndex: 'orderPrice',
          title: '下单金额',
        },
        {
          key: 'finalPrice',
          dataIndex: 'finalPrice',
          title: '最终结算金额',
        },
        {
          key: 'signVoucherState',
          dataIndex: 'signVoucherState',
          title: '签收凭证',
          render: (text: SignVoucherState) =>
            signVoucherStateDict[text] ?? text,
        },
        {
          key: 'customerInvoice',
          dataIndex: 'customerInvoice',
          title: '客户开票',
          render: (text: any) =>
            customInvoiceEnum.getLabelByValue(text) || text,
        },
        {
          key: 'returnState',
          dataIndex: 'returnState',
          title: '客户回款',
          render: (text: any) =>
            returnMoneyStatedictInvert?.[text]?.name || text,
        },
      ],
    },
  }

  return (
    <div className={styles['contianer']}>
      <div className={styles['order-info']}>
        <div className={styles['header']}>
          <span style={{ marginRight: 8 }}>对账单信息</span>
          {routeParams.id && (
            <Typography.Text
              type="danger"
              className={styles['reason']}
              title={routeParams.rejectReason}
            >
              驳回理由：{routeParams.rejectReason}
            </Typography.Text>
          )}
        </div>
        <Form
          form={form}
          className={styles['content']}
          onValuesChange={handleFormDataChange}
        >
          <Row gutter={20}>
            <Col span={8}>
              <Form.Item label="提交人">
                {enterpriseInfo?.enterpriseName}
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="对账单金额">{totalPrice.toFixed(2)}</Form.Item>
            </Col>
          </Row>
          <Row gutter={20} className={styles['remark']}>
            <Col span={8}>
              <Form.Item label="供应商备注" name="remark">
                <Input.TextArea
                  maxLength={140}
                  placeholder="请输入备注"
                  rows={5}
                  showCount
                ></Input.TextArea>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </div>
      <div className={styles['order-detail']}>
        <Row justify="space-between" className={styles['header']}>
          <span>订单明细 （{dataSource.length}）</span>
          {routeParams.id ? (
            <Space size={16}>
              <Button size="middle" onClick={handleAddClick}>
                新增订单
              </Button>
              <Button size="middle" onClick={onDelete} style={{ color: 'red' }}>
                删除
              </Button>
            </Space>
          ) : (
            <span className="gray-info">核对无误后提交</span>
          )}
        </Row>
        <div className={styles['table-container']}>
          <TableAntd
            dataSource={dataSource}
            listColumn={formConfig['订单明细'].columns}
            Y={340}
            showSize
            loading={false}
            onChangeCheck={onChangeCheck}
          ></TableAntd>
        </div>
      </div>
      <div className={styles['bottom-buttons-container']}>
        <Space>
          <div>
            <Button onClick={handleClosePage}>取消</Button>
          </div>
          <Button
            type="primary"
            onClick={handleSubmit}
            className={styles['button-item']}
            loading={isSubmitButtonLoading}
          >
            提交
          </Button>
        </Space>
      </div>
      <AddOrderModal
        visible={isAddModalVisivle}
        modalConfirm={handleAddFinished}
        modalCancel={handleAddOrderModalCancel}
        excludeOrderIds={dataSource.map((item) => item.id)}
        originRemovedList={originRemovedList}
      />
    </div>
  )
}
import useHook from './hooks'
import styles from './style.module.scss'
import TableAntd from '../../components/TableAntd'
import { Button, Col, Form, Input, Row, Space, Typography } from 'antd'
import { orderDetailLinkRender } from '../orderassurance/Lander'
import AddOrderModal from './components/AddOrderModal'
import moment from 'moment'
import {
  SignVoucherState,
  returnMoneyStatedictInvert,
  signVoucherStateDict,
} from '../../tools/state'
import { customInvoiceEnum } from '../../global/enums'

export default function FinancialReconciliationEdit() {
  const {
    form,
    hooksState,
    totalPrice,
    enterpriseInfo,
    onChangeCheck,
    handleClosePage,
    handleSubmit,
    handleFormDataChange,
    handleAddClick,
    handleAddOrderModalCancel,
    onDelete,
    handleAddFinished,
  } = useHook()

  const {
    dataSource,
    isSubmitButtonLoading,
    isAddModalVisivle,
    routeParams,
    originRemovedList,
  } = hooksState

  const formConfig = {
    订单明细: {
      columns: [
        {
          key: 'orderNo',
          dataIndex: 'orderNo',
          title: '客户订单号',
          render: orderDetailLinkRender,
        },
        {
          key: 'customer',
          dataIndex: 'customer',
          title: '客户名称',
        },
        {
          key: 'platform',
          dataIndex: 'platform',
          title: '下单平台',
        },

        {
          key: 'orderTime',
          dataIndex: 'orderTime',
          title: '下单时间',
          render: (text: any) => moment(text).format('YYYY-MM-DD HH:mm:ss'),
        },
        {
          key: 'orderPrice',
          dataIndex: 'orderPrice',
          title: '下单金额',
        },
        {
          key: 'finalPrice',
          dataIndex: 'finalPrice',
          title: '最终结算金额',
        },
        {
          key: 'signVoucherState',
          dataIndex: 'signVoucherState',
          title: '签收凭证',
          render: (text: SignVoucherState) =>
            signVoucherStateDict[text] ?? text,
        },
        {
          key: 'customerInvoice',
          dataIndex: 'customerInvoice',
          title: '客户开票',
          render: (text: any) =>
            customInvoiceEnum.getLabelByValue(text) || text,
        },
        {
          key: 'returnState',
          dataIndex: 'returnState',
          title: '客户回款',
          render: (text: any) =>
            returnMoneyStatedictInvert?.[text]?.name || text,
        },
      ],
    },
  }

  return (
    <div className={styles['contianer']}>
      <div className={styles['order-info']}>
        <div className={styles['header']}>
          <span style={{ marginRight: 8 }}>对账单信息</span>
          {routeParams.id && (
            <Typography.Text
              type="danger"
              className={styles['reason']}
              title={routeParams.rejectReason}
            >
              驳回理由：{routeParams.rejectReason}
            </Typography.Text>
          )}
        </div>
        <Form
          form={form}
          className={styles['content']}
          onValuesChange={handleFormDataChange}
        >
          <Row gutter={20}>
            <Col span={8}>
              <Form.Item label="提交人">
                {enterpriseInfo?.enterpriseName}
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="对账单金额">{totalPrice.toFixed(2)}</Form.Item>
            </Col>
          </Row>
          <Row gutter={20} className={styles['remark']}>
            <Col span={8}>
              <Form.Item label="供应商备注" name="remark">
                <Input.TextArea
                  maxLength={140}
                  placeholder="请输入备注"
                  rows={5}
                  showCount
                ></Input.TextArea>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </div>
      <div className={styles['order-detail']}>
        <Row justify="space-between" className={styles['header']}>
          <span>订单明细 （{dataSource.length}）</span>
          {routeParams.id ? (
            <Space size={16}>
              <Button size="middle" onClick={handleAddClick}>
                新增订单
              </Button>
              <Button size="middle" onClick={onDelete} style={{ color: 'red' }}>
                删除
              </Button>
            </Space>
          ) : (
            <span className="gray-info">核对无误后提交</span>
          )}
        </Row>
        <div className={styles['table-container']}>
          <TableAntd
            dataSource={dataSource}
            listColumn={formConfig['订单明细'].columns}
            Y={340}
            showSize
            loading={false}
            onChangeCheck={onChangeCheck}
          ></TableAntd>
        </div>
      </div>
      <div className={styles['bottom-buttons-container']}>
        <Space>
          <div>
            <Button onClick={handleClosePage}>取消</Button>
          </div>
          <Button
            type="primary"
            onClick={handleSubmit}
            className={styles['button-item']}
            loading={isSubmitButtonLoading}
          >
            提交
          </Button>
        </Space>
      </div>
      <AddOrderModal
        visible={isAddModalVisivle}
        modalConfirm={handleAddFinished}
        modalCancel={handleAddOrderModalCancel}
        excludeOrderIds={dataSource.map((item) => item.id)}
        originRemovedList={originRemovedList}
      />
    </div>
  )
}
